import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "admin-note-list" };
const _hoisted_2 = { class: "newAdminNote" };
const _hoisted_3 = { class: "editAdminNote" };
const _hoisted_4 = { style: { "white-space": "pre-wrap" } };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
import { ref, watchEffect } from "vue";
import useAdminNotes from "@/composables/useAdminNotes";
import { formatDateTimeWithoutSeconds } from "@/utils/utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminNoteList',
    props: {
        noteableId: {},
        noteableType: {},
        mode: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const mode = ref(props.mode);
        const noteableId = ref(props.noteableId);
        const noteableType = ref(props.noteableType);
        watchEffect(() => {
            mode.value = props.mode;
            noteableId.value = props.noteableId;
            noteableType.value = props.noteableType;
        });
        const { notes, fetchByNoteableId, store, updateContent, deleteById } = useAdminNotes(mode, noteableId, noteableType);
        const create = ref(false);
        const edit = ref(false);
        const editNoteId = ref(0);
        const editContent = ref('');
        const send = async () => {
            const note = {
                content: editContent.value,
                noteableId: props.noteableId,
                noteableType: props.noteableType,
                isAutoGenerated: false,
            };
            if (await store(note)) {
                create.value = false;
                editContent.value = '';
                fetchByNoteableId();
            }
        };
        const update = async () => {
            if (await updateContent(editNoteId.value, editContent.value)) {
                edit.value = false;
                editContent.value = '';
                editNoteId.value = 0;
            }
            fetchByNoteableId();
        };
        const editNote = (id) => {
            if (!id) {
                window.alert('IDが不正です');
                return;
            }
            editContent.value = notes.value.find((note) => note.id === id)?.content || '';
            editNoteId.value = id;
            edit.value = true;
        };
        const deleteNote = (id) => {
            if (!id || !confirm('削除しますか？')) {
                return;
            }
            deleteById(id);
        };
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_table = _resolveComponent("v-table");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createVNode(_component_v_btn, {
                    onClick: _cache[0] || (_cache[0] = ($event) => (create.value = true))
                }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("新しいメモを作成する")
                    ])),
                    _: 1,
                    __: [5]
                }, 512), [
                    [_vShow, props.mode != 'system' && (!create.value || !edit.value)]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_textarea, {
                        modelValue: editContent.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((editContent).value = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("button", { onClick: send }, [
                        _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("mdi-content-save-outline")
                            ])),
                            _: 1,
                            __: [6]
                        })
                    ]),
                    _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event) => (create.value = false))
                    }, [
                        _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("mdi-close")
                            ])),
                            _: 1,
                            __: [7]
                        })
                    ])
                ], 512), [
                    [_vShow, create.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_v_textarea, {
                        modelValue: editContent.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((editContent).value = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("button", { onClick: update }, [
                        _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("mdi-content-save-outline")
                            ])),
                            _: 1,
                            __: [8]
                        })
                    ]),
                    _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = ($event) => (edit.value = false))
                    }, [
                        _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode("mdi-close")
                            ])),
                            _: 1,
                            __: [9]
                        })
                    ])
                ], 512), [
                    [_vShow, edit.value]
                ]),
                _createVNode(_component_v_table, {
                    density: "compact",
                    class: "mt-2"
                }, {
                    default: _withCtx(() => [
                        _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "登録日時"),
                                _createElementVNode("th", null, "内容"),
                                _createElementVNode("th")
                            ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notes), (note) => {
                                return (_openBlock(), _createElementBlock("tr", null, [
                                    _createElementVNode("td", null, _toDisplayString(_unref(formatDateTimeWithoutSeconds)(note.createdAt)), 1),
                                    _createElementVNode("td", _hoisted_4, _toDisplayString(note.content), 1),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("button", {
                                            onClick: ($event) => (editNote(note.id))
                                        }, [
                                            _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                    _createTextVNode("mdi-note-edit-outline")
                                                ])),
                                                _: 1,
                                                __: [10]
                                            })
                                        ], 8, _hoisted_5),
                                        _createElementVNode("button", {
                                            onClick: ($event) => (deleteNote(note.id))
                                        }, [
                                            _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                    _createTextVNode("mdi-trash-can-outline")
                                                ])),
                                                _: 1,
                                                __: [11]
                                            })
                                        ], 8, _hoisted_6)
                                    ])
                                ]));
                            }), 256))
                        ])
                    ]),
                    _: 1,
                    __: [12]
                })
            ]));
        };
    }
});
